const windowScroll = {
  top() {
    window.scrollTo(0, 0);
  },
};

export const disableBodyScroll = () => {
  const scrollPosition =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;

  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
};

export const enableBodyScroll = () => {
  document.body.style.overflow = '';
  document.body.style.position = '';
  const scrollPosition = parseInt(document.body.style.top, 10);
  document.body.style.top = '';

  if (scrollPosition) {
    window.scrollTo({ top: Math.abs(scrollPosition), behavior: 'instant' });
  }
};

export default windowScroll;
